module.exports = __webpack_public_path__ + "static/media/logo-educat--white.fda1afa7.png";